import container from "../../libs/container/container";
import binder from '../../libs/utils/binder';
import preloader from "../../libs/preloader/preloader";

import { store } from '../../store';
import { setCurrentTab } from '../../store/pages/about/pageAboutSlice';
import router from "../../libs/router/router";

const amdAboutPartnersModule = (function () {
    const name = 'about__partners-module';

    const view = container.getBaseView(name);


    view.startup = function () {

        let currentTab = 'prudence-foundation';

        if(view.publicVars.currentTab) {
            currentTab = view.publicVars.currentTab;
        }

        const metaTitle = document.querySelector(view.publicVars.cssId.moduleAboutPartnersLabelNavItemCls + '-' + currentTab).dataset['meta.title'];

        store.dispatch(setCurrentTab({
            currentTab: currentTab,
            currentTabMeta: metaTitle
        }));

        preloader.init();
        preloader.setPreloadBulk(name, view.publicVars.preloadTab);

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersHeaderMediumCls, 'animate__bounce', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersLabelNavItemPrudenceFoundationCls, 'animate__fadeInDown50P', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersLabelNavItemDiscoveryCls, 'animate__fadeInDown50P', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersLabelNavItemCrfaCls, 'animate__fadeInDown50P', name, {
            dynamicPosHeight: true
        });

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersLabelNavItemEosCls, 'animate__fadeInDown50P', name, {
            dynamicPosHeight: true
        });

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersLogoPrudenceFoundationCls, 'animate__zoomIn', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersLogoDiscoveryCls, 'animate__zoomIn', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersLogoClimateResilienceCls, 'animate__zoomIn', name, {
            dynamicPosHeight: true
        });

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersLogoEosCls, 'animate__zoomIn', name, {
            dynamicPosHeight: true
        });

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersPrudenceFoundationLinkCls, 'animate__slideInRight', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersDiscoveryLinkCls, 'animate__slideInRight', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersClimateResilienceLinkCls, 'animate__slideInRight', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersEosLinkCls, 'animate__slideInRight', name, {
            dynamicPosHeight: true
        });

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersDescWrapperPrudenceFoundationCls, 'animate__fadeInDown50Px', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersDescWrapperDiscoveryCls, 'animate__fadeInDown50Px', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersDescWrapperClimateResilienceCls, 'animate__fadeInDown50Px', name, {
            dynamicPosHeight: true
        });
        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleAboutPartnersDescWrapperEosCls, 'animate__fadeInDown50Px', name, {
            dynamicPosHeight: true
        });
    };

    view.bind = function () {
        binder.bindToAll('click', view.publicVars.cssId.moduleAboutPartnersLabelNavItemCls, function() {
            if(store.getState().pageAbout.partners.currentTab !== this.dataset.tab) {
                view.methods.actionToggleTab(this.dataset.tab);
            }
        });
    };

    view.methods = {
        actionToggleTab: (tab) => {
            binder.executeForAll(view.publicVars.cssId.moduleAboutPartnersLabelNavItemCls, function(item) {
                item.classList.remove(view.publicVars.cssId.isActiveCls.substring(1));
            });

            document.querySelector(view.publicVars.cssId.moduleAboutPartnersLabelNavItemCls + '-' + tab).classList.add(view.publicVars.cssId.isActiveCls.substring(1));

            Array.from(document.querySelector(view.publicVars.cssId.moduleAboutPartnersDescriptionCardCls).classList).forEach((cls) => {
                if(cls.startsWith('is-active')) {
                    document.querySelector(view.publicVars.cssId.moduleAboutPartnersDescriptionCardCls).classList.remove(cls);
                }
            });

            document.querySelector(view.publicVars.cssId.moduleAboutPartnersDescriptionCardCls).classList.add(view.publicVars.cssId.isActiveCls.substring(1) + '-' + tab);

            container.getService('scroll').refreshScroll();

            const metaTitle = document.querySelector(view.publicVars.cssId.moduleAboutPartnersLabelNavItemCls + '-' + tab).dataset['meta.title'];

            router.route(view.publicVars.baseUrl + view.publicVars.slugPartnerDetails + '/' + tab, metaTitle, {
                trackAdd: {
                    'pageName': view.publicVars.trackAdd.basePageName + view.publicVars.slugPartnerDetails + '/' + tab,
                    'page_name': view.publicVars.trackAdd.basePageName + view.publicVars.slugPartnerDetails + '/' + tab,
                    'subsection': view.publicVars.trackAdd.subsection
                }
            });

            store.dispatch(setCurrentTab({
                currentTab: tab,
                currentTabMeta: metaTitle
            }));
        }
    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdAboutPartnersModule;